import React, { useContext } from "react";
import { Link } from "react-router-dom";

// Contexts
import { UmbracoContext } from "contexts/Umbraco";

// External components
import SVG from "react-inlinesvg";

const Logo = ({ color }) => {
    const { data } = useContext(UmbracoContext);
    const logo = data?.logo;
    return (
        <>
            {logo && (
                <Link to="/">
                    {logo && (
                        <SVG
                            preProcessor={(code) =>
                                color
                                    ? code.replace(
                                          /fill="#141535"/g,
                                          `fill="${color}"`
                                      )
                                    : code
                            }
                            src={logo.url}
                            alt={logo.altText}
                            className="logo"
                        />
                    )}
                </Link>
            )}
        </>
    );
};

export default Logo;
